var map = {
	"./style-check/tool.json": "./src/tools/style-check/tool.json",
	"./writers_brainstorm/tool.json": "./src/tools/writers_brainstorm/tool.json",
	"./writers_characters/tool.json": "./src/tools/writers_characters/tool.json",
	"./writers_cover_design/tool.json": "./src/tools/writers_cover_design/tool.json",
	"./writers_editing/tool.json": "./src/tools/writers_editing/tool.json",
	"./writers_first_draft/tool.json": "./src/tools/writers_first_draft/tool.json",
	"./writers_outline/tool.json": "./src/tools/writers_outline/tool.json",
	"./writers_plot/tool.json": "./src/tools/writers_plot/tool.json",
	"./writers_proofread/tool.json": "./src/tools/writers_proofread/tool.json",
	"./writers_publish_prep/tool.json": "./src/tools/writers_publish_prep/tool.json",
	"./writers_revision/tool.json": "./src/tools/writers_revision/tool.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/tools sync recursive ^\\.\\/[^/]+\\/tool\\.json$";